import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-text-area',
	templateUrl:'./WaTextAreaPage.html',
	styles: [],
	styleUrls:['./WaTextAreaPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaTextAreaPage
{
	mdContent_471 = `\`\`\`java
import com.jwebmp.webawesome.components.textarea.WaTextArea;
\`\`\``;
	mdContent_472 = `\`\`\`java
var ta = new WaTextArea<>();
ta.setLabel("Comments");
ta.setPlaceholder("Enter your comments...");
ta.setRows(6);
ta.setResize(TextAreaResize.Auto);
\`\`\``;
}
